export default {
  todo: 'todo',
  daily: 'daily',
  weekly: 'weekly'
};
